import React from "react";
import { Box, Button, Code, Text, Stack, ScrollArea, Badge, Title } from "@mantine/core";
import { useAppSelector } from "../hooks"; // Ersätt med korrekt import-väg till dina Redux hooks
import { useGetChecklistByChecklistIdExportQuery } from "../../openapi"; // Behåller din import
import { selectTemplateNrId } from "./checklistTemplatePageSelectors"; // Ersätt med korrekt import-väg till selectorn
import { FailedAlert } from "../components";
import ExportChecklistButton from "../app/routes/checklist/ExportTemplateButton";

const MCTempalteExportChecklist: React.FC = () => {
  const selectedTemplateNrId = useAppSelector(selectTemplateNrId);

  const {
    data: exportData,
    isLoading,
    isSuccess,
    isError,
    error,
    refetch,
    startedTimeStamp,
    fulfilledTimeStamp,
  } = useGetChecklistByChecklistIdExportQuery(
    { checklistId: selectedTemplateNrId!, excel: true },
    { skip: !selectedTemplateNrId },
  );

  const requestTime =
    isSuccess && startedTimeStamp && fulfilledTimeStamp ? fulfilledTimeStamp - startedTimeStamp : null;
  const lastRequestTimestamp = fulfilledTimeStamp ? new Date(fulfilledTimeStamp).toLocaleString("no-NO") : null;

  return (
    <Box h="100%">
      <Title order={6} mb="xs">
        Eksporter sjekkliste {selectedTemplateNrId ? `#${selectedTemplateNrId}` : ""}
      </Title>
      <Stack h="100%">
        <Box w={200}>
          <ExportChecklistButton checklistLocalId={selectedTemplateNrId} />
        </Box>
        {isSuccess && exportData && (
          <Stack gap="xs">
            <Badge color="green" leftSection={<i className="fa fa-check" />}>
              Vellykket anrop
            </Badge>
            {requestTime !== null && (
              <Text size="sm" c="dimmed">
                Anropstid: {requestTime.toFixed(2)} ms
              </Text>
            )}
            {lastRequestTimestamp && (
              <Text size="sm" c="dimmed">
                Sist kjørt: {lastRequestTimestamp}
              </Text>
            )}
          </Stack>
        )}
        {isLoading && <Text>Laster...</Text>}
        {isError && <FailedAlert />}
        {exportData && (
          <ScrollArea h={300} type="auto" offsetScrollbars>
            <Code block>{JSON.stringify(exportData, null, 2)}</Code>
          </ScrollArea>
        )}
        {!isLoading && !isError && !exportData && (
          <Text c="dimmed" italic>
            Velg en mal for å eksportere
          </Text>
        )}
      </Stack>
    </Box>
  );
};

export default MCTempalteExportChecklist;
